type Placeable = { id: string; featured?: boolean; tags: { id: string }[] };

/**
 * Where the store has to stand for the product a link names (`?product=`, a
 * bundle slot) to be on screen: the first tab, in rank order, that carries it,
 * and the full list when it is not among the featured ones the store shows
 * before "show more". Null when the store does not show that product at all.
 */
export function highlightPlacement(
  products: Placeable[],
  tags: { id: string }[],
  productId: string | null,
): { tagId: string; showMore: boolean } | null {
  if (!productId) return null;
  const product = products.find((p) => p.id === productId);
  if (!product) return null;
  const tag = tags.find((t) => product.tags.some((pt) => pt.id === t.id));
  if (!tag) return null;
  return { tagId: tag.id, showMore: product.featured !== true };
}
